import * as React from "react";
import { Link } from "react-router-dom";
import GenerateLink from "../../helpers/GenerateLink";
import { IProductSearchResult } from "../../models/product/IProductSearchResult";
import defaultImage from "../../pages/productpage/images/no_image_avail.jpg";

interface IPropsProductGrid {
  item: IProductSearchResult;
  searchString?: string;
}

const ProductGridItem = React.memo((props: IPropsProductGrid) => {
  const price = props.item.priceAndAvailability.price;

  return (
    <div
      className="bg-white rounded-lg overflow-hidden shadow-sm transition-all duration-200 hover:shadow-lg hover:-translate-y-1"
      data-insights-object-id={props.item.id}
      data-insights-query={props.searchString}
    >
      <div className="relative w-full" style={{ height: "96px" }}>
        <Link to={GenerateLink.ForProduct(props.item.id, props.item.seoName || "", props.searchString)}>
          <img
            src={props.item.picture?.thumbnail?.url || defaultImage}
            alt={props.item.name || "Product Image"}
            className="w-full h-full object-contain p-2"
          />
        </Link>
      </div>
      <div className="p-2">
        <Link
          className="text-gray-900 font-medium text-sm block hover:text-blue-600 
                    transition-colors duration-200"
          to={GenerateLink.ForProduct(props.item.id, props.item.seoName || "", props.searchString)}
        >
          {props.item.name}
        </Link>
        <div className="mt-1">
          <div className="text-base font-semibold">
            {price !== null &&
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              }).format(price)}
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProductGridItem;
